import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AtAvatarComponent, AtIconComponent, AtSkeletonComponent } from '@anothertrip/anothertrip-ds';

import { SubscriptionService } from '../../features/subscription/services/subscription.service';
import { CookieConsentService } from '../../services/cookie-consent/cookie-consent.service';

@Component({
  selector: 'app-user-profile-overlay',
  imports: [AtAvatarComponent, RouterLink, RouterLinkActive, AtIconComponent, AtSkeletonComponent],
  templateUrl: './user-profile-overlay.component.html',
  styleUrl: './user-profile-overlay.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'user-overlay' },
})
export class UserProfileOverlayComponent {
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly cookieConsent = inject(CookieConsentService);

  readonly isUserLoading: InputSignal<boolean> = input<boolean>(false);
  readonly username: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly email: InputSignal<string | undefined> = input<string | undefined>(undefined);

  protected readonly isActive = this.subscriptionService.isActive;

  // eslint-disable-next-line @angular-eslint/no-output-native -- `close` matches the overlay's dismiss semantics; renaming would break parent bindings
  readonly close = output<void>();
  readonly logout = output<void>();

  /**
   * In this order: closing the menu hands focus back to its trigger, and the kit returns focus to whatever
   * has it when its dialog opens. The other way round it records this item, which is gone with the menu.
   */
  protected openCookieSettings(): void {
    this.close.emit();
    this.cookieConsent.openSettings();
  }
}
